import React from 'react';
import { BookingStatus, PaymentStatus } from '../../types/booking';
const statusStyles: Record<BookingStatus, {
  label: string;
  className: string;
}> = {
  pending: {
    label: 'Aanvraag',
    className: 'border-amber-400/40 text-amber-300'
  },
  confirmed: {
    label: 'Bevestigd',
    className: 'border-ember/50 text-ember'
  },
  completed: {
    label: 'Afgerond',
    className: 'border-emerald-400/40 text-emerald-300'
  },
  cancelled: {
    label: 'Geannuleerd',
    className: 'border-edge text-dim'
  }
};
const paymentStyles: Record<PaymentStatus, {
  label: string;
  className: string;
}> = {
  unpaid: {
    label: 'Niet betaald',
    className: 'border-edge text-dim'
  },
  deposit_paid: {
    label: 'Aanbetaald',
    className: 'border-ember/50 text-ember'
  },
  paid: {
    label: 'Volledig betaald',
    className: 'border-emerald-400/40 text-emerald-300'
  },
  refunded: {
    label: 'Terugbetaald',
    className: 'border-edge text-dim'
  }
};
export function StatusBadge({
  status
}: {
  status: BookingStatus;
}) {
  const style = statusStyles[status];
  return <span className={`inline-flex shrink-0 whitespace-nowrap rounded-full border px-2.5 py-1 text-[10px] uppercase tracking-[0.1em] ${style.className}`} data-id="element-313" data-mp="23lbefe5chef6">
      {style.label}
    </span>;
}
export function PaymentBadge({
  status
}: {
  status: PaymentStatus;
}) {
  const style = paymentStyles[status];
  return <span className={`inline-flex shrink-0 whitespace-nowrap rounded-full border px-2.5 py-1 text-[10px] uppercase tracking-[0.1em] ${style.className}`} data-id="element-314" data-mp="1ovci7gxcod2c">
      {style.label}
    </span>;
}